import { GlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/models";
import { ReactElement } from "react";
import { ResultSectionLayout } from "../../ResultSectionLayout/ResultSectionLayout";
import { localize } from "client_legacy/ndaw/culture";
import { ItemView } from "./ItemView/ItemView";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";
import { TimeZone } from "client/DateAndTime/timezones";
import { ContactSource } from "client/Api/Email/contacts";

export type RecentlyOpenedViewProps = {
	recentSearchResults: readonly GlobalSearchItemPersistedModel[];
	timezone: TimeZone;
	onRemove: (item: GlobalSearchItemPersistedModel) => void;
	onClear: () => void;
	onOpenContactDetails: (id: string, source: ContactSource) => void;
	onDismiss: () => void;
	tabbableIndex: number | null;
};

export const RecentlyOpenedView = (props: RecentlyOpenedViewProps): ReactElement => {
	const {
		recentSearchResults,
		timezone,
		onRemove,
		onClear,
		onOpenContactDetails,
		onDismiss,
		tabbableIndex
	} = props;

	const isMobile: boolean = useWorkspaceMediaQuery(MediaQueryKind.Mobile);

	return (
		<ResultSectionLayout
			trackingId="recently-opened-list"
			title={localize("_RecentlyOpened")}
			onClearAll={() => onClear()}
		>
			<ResultSectionLayout.List>
				{
					recentSearchResults.map((item, index): ReactElement => (
						<ItemView
							key={index}
							item={item}
							isMobile={isMobile}
							timezone={timezone}
							itemIndex={index}
							onRemove={onRemove}
							onOpenContactDetails={onOpenContactDetails}
							onDismiss={onDismiss}
							tabIndex={index === tabbableIndex ? 0 : -1}
						/>
					))
				}
			</ResultSectionLayout.List>
		</ResultSectionLayout>
	);
};
RecentlyOpenedView.displayName = "RecentlyOpenedView";